import {FC, useState} from 'react'
import {useUserProfileContext} from '../../context/UserProfileContext'
import {MemberProfile} from './components/MemberProfile'
import MemberCategoryChips from './components/MemberCategoryChips'
import {MemberLanguages} from './components/MemberLanguages'
import {MemberActions} from './components/MemberActions'
import {MemberImage} from './components/MemberImage'
import {MemberTabs} from './components/MemberTabs'
import {ProfileMemberBadges} from '../profileMembers/components/ProfileMemberBadges'
import {ProfileMemberLanguages} from '../profileMembers/components/ProfileMemberLanguages'
import {ProfileMemberIntroductions} from '../profileMembers/components/ProfileMemberIntroductions'
import {ProfileMemberSocials} from '../profileMembers/components/ProfileMemberSocials'
import {useHistory} from 'react-router-dom'

const MemberDetailPage: FC = () => {
  const history = useHistory()
  const [activeTab, setActiveTab] = useState('biography')
  const {data, loading} = useUserProfileContext()
  const {
    expertise = [],
    firstName,
    surname,
    bioPresentation,
    city,
    languages = [],
    profilePicture,
    picFooter,
    subscription,
    aliasTitle,
    introduction = [],
    socialMediaProfiles = [],
    isFoundingMember,
    // PR-I-85: partnerStatus manda el status del Partner asociado (creado por PR-I-86 al
    // guardar expertise). El boton Book Expertise solo aparece cuando esta 'active'.
    partnerStatus,
    // PR-I-85: Partner.id — necesario para armar la URL de booking. Sin este id el navigation
    // caia en 404 porque usabamos User.id.
    partnerId,
  } = data ?? {}

  return (
    <div className='member-detail'>
      <div className='help-center-sections w-100 tap-flex-center justify-content-start mb-5'>
        <div
          className='nb-link-underline-500 w-auto cursor-pointer'
          onClick={() => history.goBack()}
        >
          Back
        </div>
      </div>
      <div className='member-detail__container'>
        <div className='member-detail__left'>
          <div className='member-detail__info-section'>
            {/* PR-I-85: hasExpertise dinamico. Cuando el member registra su expertise (via
                /profile/edit-expertise) el chip "Expert" aparece automaticamente en el header
                publico. Antes estaba hard-coded a false porque expertise era exclusivo de
                expert-partners. */}
            <ProfileMemberBadges
              hasExpertise={(expertise?.length ?? 0) > 0}
              subscription={subscription}
              isFoundingMember={isFoundingMember}
            />
            <MemberProfile
              aliasTitle={aliasTitle ?? ''}
              firstName={firstName}
              surname={surname}
              bioPresentation={bioPresentation}
              city={city}
            />
            {/* WP-T5: public (staff-confirmed) member categories */}
            <MemberCategoryChips userId={data?.user} />
          </div>
          <ProfileMemberLanguages languages={languages} />
          <MemberActions
            memberId={data?.user}
            hasExpertise={(expertise?.length ?? 0) > 0}
            partnerStatus={partnerStatus}
            partnerId={partnerId}
          />
          {introduction && introduction.length > 0 && (
            <ProfileMemberIntroductions introduction={introduction} />
          )}

          {socialMediaProfiles && socialMediaProfiles.length > 0 && (
            <ProfileMemberSocials socialMediaProfiles={socialMediaProfiles} />
          )}
        </div>
        <MemberImage profilePicture={profilePicture} picFooter={picFooter} loading={loading} />
      </div>
      <MemberTabs activeTab={activeTab} onTabChange={setActiveTab} />
    </div>
  )
}

export {MemberDetailPage}
